import { render, staticRenderFns } from "./EventPartsPage.vue?vue&type=template&id=48c74512&"
import script from "./EventPartsPage.vue?vue&type=script&lang=js&"
export * from "./EventPartsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports